import React from 'react'
import { STATUS_BADGES } from './waitingListConstants'

export default function StatusBadge({ status, children, title }) {
  const badge = STATUS_BADGES[status] ?? STATUS_BADGES.queued

  return (
    <span
      title={title}
      className={`inline-flex items-center justify-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold whitespace-nowrap ${badge.className}`}
    >
      {children ?? badge.label}
    </span>
  )
}
